import React from "react";
import dom from 'react-dom/client';

import {Notification, Popup} from "../components/popups";
import LatchButton, {LatchController} from "../components/latch-button";
import {selectElement, iframeCx} from "./wireframe-editor";

export default function PictureButton() {
	const getIframe = React.useContext(iframeCx)!;

	const abort = new AbortController();
	const controller = new LatchController();

	controller.bind({
		async onLatch() {
			const iframe = getIframe();

			const element = await selectElement(iframe!, abort.signal, 'img');

			controller.unlatch();

			const modal = Popup({
				id: 'image-picker',
				children: <PickerContent onSubmit={img => {
					element.replaceWith(img);
					modal.close();
				}} />
			});
		},

		onCancel() {
			abort.abort('cancel');
		},

		onEnd() {

		}
	})

	return <LatchButton controller={controller} data-icon={'\ue3f4'}>
		Bild Bearbeiten
	</LatchButton>;
}

const uploadModeHelp = `Der Anfügemodus
\t· Data URL - Das gesamte Bild wird Base64-kodiert und als URL in das \`src\` Attribut geschrieben. Das Ganze bild liegt im Quellcode
\t· Upload - Das Bild wird in den Wireframe Ordner hochgeladen und per URL auf den Wireframe Ordner in das Wireframe verlinkt.  
`;

function PickerContent(props: { onSubmit: (img: HTMLImageElement) => void }) {
	const onSubmit = (data: FormData) => {
		const file = Object.fromEntries(data) as {
			mode: typeof mode,
			resource: File | null,
		} & ({} | {embed?: 'embed-url', 'image-url': string});

		if (!file.resource || !('image-url' in file))
			return Notification({heading: 'Kein Bild', body: <p>Bitte ein Bild anfügen.</p>, style: 'warning'})

		const img = document.createElement('img');

		if ('embed' in file)
			img.src = file["image-url"];

		else if (file.mode == 'Data URL')
			img.src = URL.createObjectURL(file.resource);

		else
			return Notification({
				heading: 'Noch nicht implementiert',
				style: 'info',
				body: <p>
					Ich hatte noch keine Zeit den notwendigen n8n Workflow hier zu programmieren. Das heißt es geht noch
					net. Kannst aber den URL Modus nehmen.
				</p>
			});

		props.onSubmit(img);
	};

	const file = React.useRef<HTMLInputElement>(null);
	const [img, setImg] = React.useState<File | null>(null);
	const [mode, setMode] = React.useState('Data URL' as 'Data URL' | 'Hochladen');

	return <>
		<button className="symbolic close-btn" data-icon={"\ue5cd"}
				// @ts-ignore
				command="request-close"
				commandfor="image-picker"/>

		<form action={onSubmit}>
			<div className='dialog-header'>
				<h1>Bild austauschen</h1>
			</div>

			<div className='search-box combined-tool' data-label='Bild Link einfügen'>
				<input type={"url"}
					   placeholder="https://share.google/099pkmKKJKwJ3o4C5"
					   name='image-url'
					   id='image-url' />

				<button className='symbolic' data-icon={'\u{fffb5}'} name='embed' value='embed-url' />
			</div>

			<hr />

			<div className='search-box combined-tool'>
				<input type='search' placeholder='In AkroServices Bildbibliothek suchen' name='stock-search'
				       onChange={() => Notification({
						   heading: 'Waah',
						   style: 'info',
						   body: <p>
							   <img src="https://gifdb.com/images/high/laughing-meme-498-x-354-gif-5r4ksuis8tvqskwe.gif"
						            style={{float: 'left', maxHeight: `48px`}}/>
							   <p>Sike die gibt's noch net</p>
						   </p>
					   })}/>
				<button className='symbolic' data-icon={'\ue8b6'} type='button' />
			</div>

			<div className='dropzone'
				 onDragOver={e => [...e.dataTransfer.items].length > 0 && e.preventDefault()}
				 onDrop={drop => {
					 drop.preventDefault();
					 setImg(drop.dataTransfer.items[0].getAsFile());
				 }}
				 onClick={() => file.current?.click?.()}>

				{img
					? <img src={URL.createObjectURL(img)} alt='Neues Foto'/>
					: <span className='picker-content' data-icon={'\uf09b'}>Bild Auswählen</span>
				}

				<input type='file' name='resource' accept='image/*' ref={file}
				       onChange={e => e.currentTarget?.files && setImg(e.currentTarget.files[0])}/>
			</div>

			<label title={uploadModeHelp} data-icon-after={'\ue88e'}>Bildmodus</label>
			<div className='radio-slider'>
				{['Data URL', 'Hochladen']
					.map(i => <label key={`mode-${i}`}>
							{i}
							<input type='radio' name='mode' value={i} checked={mode == i}
							       onChange={e => setMode(e.currentTarget.value as typeof mode)} />
						</label>
					)}
			</div>

			<div className='buttons'>
				{/* @ts-ignore */}
				<button data-icon={'\ue5cd'} command="close" commandfor='image-picker' type='button'>Abbrechen</button>
				<button data-icon={'\uf09b'}>Einsetzen</button>
			</div>
		</form>
	</>;
}